import { all, takeEvery, put, call } from 'redux-saga/effects';
import reduxActions from './actions';
import { tableConfig } from '../../../settings/index';
import Api from '../../../helpers/api';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import { t } from '../../../i18n';

const api = new Api('workers');
const bulkFormRequestApi = new Api('workers/hr_forms/bulk_create');

function formatFilters(filters) {
  return filters.map(filter => {
    if (filter.key === 'accreditation_ids') {
      filter.searchable = true;
    }

    return filter;
  });
}

function* loadData({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;
    const district = payload.district && !Array.isArray(payload.district) ? [payload.district] : payload.district || [];

    const result = yield call(
      sendRequest,
      api.load,
      { search: { ...payload, page, pageSize, column, order, filter, district } },
      notifications.REQUEST_ERROR,
    );

    if (result.data) {
      const {
        records: data,
        totalCount,
        filteredCount,
        sortableColumns,
        filters,
        saved_searches,
        bulk_actions,
        actions,
      } = result.data;

      yield put(
        reduxActions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns,
          filters: formatFilters(filters),
          savedSearches: saved_searches,
          bulk_actions,
          actions,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* bulkRequest({ payload }) {
  try {
    const { page = 1, pageSize = tableConfig.pageSize, column, order, filter = '' } = payload;
    const district = payload.district && !Array.isArray(payload.district) ? [payload.district] : payload.district || [];

    const result = yield call(
      sendRequest,
      bulkFormRequestApi.createItem,
      { search: { ...payload, page, pageSize, column, order, filter, district } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200) {
      yield put(reduxActions.bulkRequestSuccess());
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.talent.bull_form_request_modal.on_submit_error_message'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(reduxActions.LOAD, loadData), takeEvery(reduxActions.BULK_FORM_REQUEST_REQUEST, bulkRequest)]);
}
